import { serverTimestamp, addDoc } from "firebase/firestore";
import { useSelector } from "react-redux";
import { selectCurrentEventId } from "modules/event/selectors";
import logger from "logging/logger";
import { getAudioReactionsRef } from "modules/audioReactions/firestore";
import { AudioReactionsTypes } from "modules/audioReactions/constants";
import { useCallback } from "react";
import { selectUserId } from "modules/auth/redux/selectors";

export const useAudioReactions = () => {
  const userId = useSelector(selectUserId);
  const eventId = useSelector(selectCurrentEventId);

  const addAudioReaction = useCallback(
    async (reactionType: AudioReactionsTypes) => {
      if (!userId || !eventId) return;

      try {
        const reactionsRef = getAudioReactionsRef(eventId);
        await addDoc(reactionsRef, {
          time: serverTimestamp(),
          reactionType,
          userId,
        });
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : "";
        logger.error(
          `[useAudioReactions][addAudioReaction] err: ${errorMessage} event: ${eventId}`,
        );
      }
    },
    [userId, eventId],
  );

  return {
    addAudioReaction,
  };
};
